<template>
  <div class="modal" ref="modal" :class="{ 'modal--visible': modals.length }">
    <transition-group name="fade-up">
      <div
        class="modal__content"
        :class="`modal__content--${modal.position}`"
        ref="content"
        v-for="(modal, i) in modals"
        :key="modal.id ?? i"
        @click.self="closeLast"
      >
        <component
          v-show="i === modals.length - 1"
          :is="modal.component"
          v-bind="modal.options"
          @close="closeLast"
          @closeAll="closeAll"
        ></component>
      </div>
    </transition-group>
  </div>
</template>

<script setup>
/**
 * Imports
 */
import { computed, watch } from "vue";
import { useDefaultStore } from "@/shared/stores/default";
import { useRoute } from "vue-router";

/**
 * Variables
 */
const defaultStore = useDefaultStore();
const route = useRoute();

/**
 * Computed
 */
const modals = computed(() => {
  return defaultStore.modals;
});

/**
 * Methods
 */
function closeLast() {
  return defaultStore.modals.splice(defaultStore.modals.length - 1, 1);
}

function closeAll(callback) {
  if (callback) {
    callback();
  }
  defaultStore.modals = [];
}

/**
 * Hooks, watchers and calls
 */
watch(
  () => modals.value.length,
  (val) => {
    if (val > 0) {
      document.body.classList.add("no-overflow");
    } else {
      document.body.classList.remove("no-overflow");
    }
  }
);

// Закрываем модалки при любой смене маршрута. Раньше watched-выражение `route.name && route.params`
// сравнивалось по ссылке (один и тот же объект params) → срабатывало нестабильно.
watch(
  () => route.fullPath,
  () => {
    defaultStore.modals = [];
  }
);
</script>

<style lang="stylus">
.modal {
  position: fixed
  left: 0
  top: 0
  width: 100%
  height: 100%
  z-index: 999
  display: grid
	overflow: auto
	pointer-events: none
	opacity: 0
  transition var(--transition)
	background: rgba(189, 189, 189, 0.50);
	backdrop-filter: blur(12px);
  scrollbar-gutter stable
  scrollbar-width none

	&--visible {
		pointer-events: auto
		opacity: 1
		visibility visible
	}

  &__content {
    width: 100%
		height: max-content
    min-height: 100%
    display: flex
    align-items: center
    justify-content: center
		padding: 30px 0 45px
		position: absolute
		top: 0
		bottom: 0
		left: 0
		right: 0
		z-index: 1
		pointer-events: none

    &--top {
      align-items flex-start
      padding-top 100px
    }

    &:last-child {
			pointer-events: auto
    }
  }
}
</style>
